interface TranslateProps {
  [key: string]: { en: string; de: string };
}

export const translate: TranslateProps = {
  bookNow: {
    en: "BOOK NOW",
    de: "JETZT BUCHEN",
  },
  checkIn: {
    en: "Check-In",
    de: "Anreise",
  },
  checkOut: {
    en: "Check-Out",
    de: "Abreise",
  },
  guests: {
    en: "Guests",
    de: "Gäste",
  },
  guest: {
    en: "Guest",
    de: "Gast",
  },
  signUpNews: {
    en: "SIGN UP FOR NEWS & OFFERS",
    de: "MELDEN SIE SICH HIER AN FÜR AKTUELLE NEWS & ANGEBOTE",
  },
  yourEmail: {
    en: "YOUR EMAIL",
    de: "IHRE E-MAIL",
  },
  submit: {
    en: "Submit",
    de: "Submit",
  },
  subscribe: {
    en: "Subscribe",
    de: "Abonnieren",
  },
  bedrooms: {
    en: "Rooms & Suites",
    de: "Zimmer & Suiten",
  },
  meetingsAndEvents: {
    en: "Meetings & Events",
    de: "Meetings & Events",
  },
  eatAndDrink: {
    en: "Eat & Drink",
    de: "Essen & Trinken",
  },
  arrival: {
    en: "Arrival",
    de: "Ankunft",
  },
  departure: {
    en: "Departure",
    de: "Abfahrt",
  },
  rooms: {
    en: "Rooms",
    de: "Zimmer",
  },
  venue: {
    en: "Venue",
    de: "Veranstaltungsort",
  },
  restaurantName: {
    en: "RESTAURANT NAME",
    de: "RESTAURANT NAME",
  },
  date: {
    en: "Date",
    de: "Datum",
  },
  time: {
    en: "Time",
    de: "Time",
  },
  name: {
    en: "Name",
    de: "Name",
  },
  nameMayus: {
    en: "Name",
    de: "Name",
  },
  firstName: {
    en: "First Name",
    de: "Vorname",
  },
  lastName: {
    en: "Last Name",
    de: "Familienname",
  },
  companyName: {
    en: "Company Name",
    de: "Firmenname",
  },
  nameHere: {
    en: "NAME HERE",
    de: "HIER NAME",
  },
  email: {
    en: "Email",
    de: "Email",
  },
  emailMayus: {
    en: "EMAIL",
    de: "EMAIL",
  },
  emailHere: {
    en: "EMAIL HERE",
    de: "EMAIL",
  },
  phone: {
    en: "Phone",
    de: "Telefon",
  },
  phoneHere: {
    en: "PHONE NUMBER HERE",
    de: "TELEFONNUMMER",
  },
  makeAnInquiry: {
    en: "MAKE AN INQUIRY",
    de: "JETZT ANFRAGEN",
  },
  getInTouch: {
    en: "Get in touch",
    de: "In Kontakt kommen",
  },
  telephone: {
    en: "TELEPHONE",
    de: "TELEFONNUMMER",
  },
  yourMessage: {
    en: "YOUR MESSAGE",
    de: "IHRE NACHRICHT",
  },
  send: {
    en: "SEND",
    de: "ABSENDEN",
  },
  enquireNow: {
    en: "INQUIRE NOW",
    de: "JETZT ANFRAGEN",
  },
  viewAllEvents: {
    en: "VIEW ALL EVENTS",
    de: "ALLE EREIGNISSE ANZEIGEN",
  },
  viewAllVouchers: {
    en: "VIEW ALL VOUCHERS",
    de: "ALLE VOUCHERS ANZEIGEN",
  },
  findOutMore: {
    en: "FIND OUT MORE",
    de: "NÄHERE INFORMATIONEN",
  },
  all: {
    en: "All",
    de: "Alle",
  },
  openingTimes: {
    en: "Opening Times",
    de: "Öffnungszeiten",
  },
  menus: {
    en: "Menus",
    de: "Menüs",
  },
  bookATable: {
    en: "BOOK A TABLE",
    de: "TISCH RESERVIEREN",
  },
  backToRestaurants: {
    en: "BACK TO RESTAURANTS AND BARS",
    de: "ZURÜCK ZU RESTAURANTS UND BARS",
  },
  viewAllRooms: {
    en: "VIEW ALL ROOMS & SUITES",
    de: "ALLE ZIMMER & SUITEN ANZEIGEN",
  },
  popupTitle: {
    en: "Become a member and book direct for 20% off bedroom rates",
    de: "Werden Sie Mitglied und buchen Sie direkt und erhalten Sie 20 % Ermäßigung auf die Zimmerpreise",
  },
  popupText: {
    en: "Also receive a complimentary residents drink and light bite any day between 11pm - 12pm on your stay.",
    de: "Außerdem erhalten Sie während Ihres Aufenthalts jeden Tag zwischen 23:00 und 12:00 Uhr ein kostenloses Hausgetränk und einen leichten Snack.",
  },
  signUp: {
    en: "SIGN UP",
    de: "SIGN UP",
  },
  formNewsletterSuccess: {
    en: "Thanks for subscribing",
    de: "Danke fürs Abonnieren",
  },
  formNewsletterExisting: {
    en: "You're already subscribed",
    de: "Du bist bereits Abonniert",
  },
  formBookingSuccess: {
    en: "We have successfully saved your data.",
    de: "Wir haben Ihre Daten erfolgreich gespeichert.",
  },
  formBookingError: {
    en: "We were not able to save your data. Please try again or contact us at <a href='info@imperialridingschool-vienna.com'>info@imperialridingschool-vienna.com</>",
    de: "Wir konnten Ihre Daten nicht speichern. Bitte versuchen Sie es erneut oder kontaktieren Sie uns unter info@imperialridingschool-vienna.com",
  },
};
